import './chat/assetBase';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import { initSentry } from './config/sentry';
import { installGlobalErrorHandlers } from './utils/bugReporter';

// Initialize Sentry first (before React)
if (!window.__COOKUP_CHAT_PLAYER__) initSentry();

// Install global error handlers
if (!window.__COOKUP_CHAT_PLAYER__) installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById(window.__COOKUP_CHAT_PLAYER__ ? 'engine-root' : 'root'));
const renderApp = () => root.render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);
if (window.__COOKUP_CHAT_PLAYER__) {
  let started = false;
  window.cookupStartChatEngine = () => {
    if (started || window.__COOKUP_CHAT_RETIRED__) return;
    started = true;
    renderApp();
  };
  window.cookupDisposeChatEngine = () => {
    window.__COOKUP_CHAT_RETIRED__ = true;
    if (started) root.unmount();
    delete window.__COOKUP_CHAT_ASSETS__;
    delete window.__COOKUP_CHAT_TABLES__;
    delete window.cookupStartChatEngine;
    delete window.cookupDisposeChatEngine;
  };
  // A session picker must not allocate a DAW engine before a session is opened.
  if (window.__COOKUP_CHAT_NEEDS_ENGINE__) window.cookupStartChatEngine();
} else renderApp();
